<!-- 予約状況編集画面 予約状況編集結果画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<style scoped></style>
<template>
  <div class="contents" id="wiga1Detail">
    <section id="mainContent">
      <h2>予約状況編集結果画面</h2>
      <p>予約状況の変更が完了しました。</p>
    </section>
    <div class="btnLst"><button class="backBtn" v-on:click="onBack">受診者抽出画面へ戻る</button></div>
  </div>
</template>
<script>
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'
  
  export default {
    // モジュール名
    name: 'WIGA1Detail2',
		// 使用コンポーネント
		data() {
			return {
      }
    },
		created: function() {

			UtilityConsoleLog.consoleLog('WIGA1Detail2::created Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog('WIGA1Detail2::created End')
		},
    methods: {
      // 表示系--------------------------------------------------S
      // 初期表示
      firstDisplay: function () {
        
        UtilityConsoleLog.consoleLog('WIGA1Detail2::firstDisplay Start')

				UtilityConsoleLog.consoleLog('WIGA1Detail2::firstDisplay End')
      },
      // 表示系--------------------------------------------------E
      // イベント系----------------------------------------------S
      // 戻るボタン押下時
      onBack: function () {
        UtilityConsoleLog.consoleLog('WIGA1Detail2::onBack Start')

        UtilityConsoleLog.consoleLog('WIGA1Detail2::onBack Start')
        // 受診者抽出画面へ遷移する
        this.$router.push("/WIGA1")
      },
      // イベント系----------------------------------------------E
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WIGA1/WIGA1Detail2.vue